"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _apartment = require("@/api/apartment.api");
var _ApartmentTable = _interopRequireDefault(require("./components/ApartmentTable.vue"));
var _building = require("@/api/building.api");
var _ApartmentModal = _interopRequireDefault(require("./components/ApartmentModal.vue"));
var _apartment2 = require("@/types/apartment");
var ApartmentPage = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(ApartmentPage, _Vue);
  var _super = (0, _createSuper2.default)(ApartmentPage);
  function ApartmentPage() {
    var _this;
    (0, _classCallCheck2.default)(this, ApartmentPage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "data", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "total", 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "query", {
      page: 1,
      limit: 10,
      search: "",
      status: "",
      buildingId: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "buildings", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ApartmentStatusTrans", _apartment2.ApartmentStatusTrans);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    return _this;
  }
  (0, _createClass2.default)(ApartmentPage, [{
    key: "created",
    value: function created() {
      this.fetchData();
      this.fetchBuildings();
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(apartment) {
      this.$refs.ApartmentModal.handleUpdate(apartment);
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.$refs.ApartmentModal.handleCreate();
    }
  }, {
    key: "handleQuery",
    value: function handleQuery() {
      this.query.page = 1;
      this.fetchData();
    }
  }, {
    key: "fetchBuildings",
    value: function () {
      var _fetchBuildings = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(search) {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _building.buildingApi.findAll({
                  search: search,
                  page: 1,
                  limit: 50
                });
              case 2:
                res = _context.sent;
                this.buildings = res.data.buildings;
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function fetchBuildings(_x) {
        return _fetchBuildings.apply(this, arguments);
      }
      return fetchBuildings;
    }()
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                this.loading = true;
                _context2.next = 4;
                return _apartment.apartmentApi.findAll(this.query);
              case 4:
                res = _context2.sent;
                this.data = res.data.apartments;
                this.total = res.data.total;
              case 7:
                _context2.prev = 7;
                this.loading = false;
                return _context2.finish(7);
              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0,, 7, 10]]);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
  return ApartmentPage;
}(_vuePropertyDecorator.Vue);
ApartmentPage = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ApartmentTable: _ApartmentTable.default,
    ApartmentModal: _ApartmentModal.default
  }
})], ApartmentPage);
var _default = ApartmentPage;
exports.default = _default;